import { render, staticRenderFns } from "./InnerPage.vue?vue&type=template&id=5b10f1f2&scoped=true&"
import script from "./InnerPage.vue?vue&type=script&lang=js&"
export * from "./InnerPage.vue?vue&type=script&lang=js&"
import style0 from "./InnerPage.vue?vue&type=style&index=0&id=5b10f1f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b10f1f2",
  null
  
)

export default component.exports